/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, gridSize, borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const UploadErrorMessage = styled.div({
  marginTop: `${gridSize() / 2}px`,
  display: 'flex',
  alignItems: 'center',
});

export const dropzoneStyles = {
  width: '200px',
  height: '200px',
  borderWidth: '2px',
  borderColor: token('color.border', colors.N40),
  borderStyle: 'dashed',
  borderRadius: `${borderRadius() * 2}px`,
  color: token('color.text.subtlest', colors.N400),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: `${gridSize()}px`,
  cursor: 'pointer',
};
